import { Row, Space, Typography } from "antd";
import K from "utilities/constants";
import { displayDollar, displayPercentage } from "utilities/tableUtility";
import { CommissionDetailItem } from "../commissionDetailItem";
import { getThresholdValue } from "../../../../billingCommissions/commission/utils";
import { epochTimeToDashUSFormat } from "../../../../../utilities/dateUtility";
import { EditStartDateButton } from "./editStartDateButton/editStartDateButton";

const { Title, Text } = Typography;

export const CommissionPlanDetails = ({
  plan,
  clientName,
  commissionId = null,
  lastRuleStartDate = null,
  startDate = null,
  onStartDateUpdated = null,
  isEditAllowed = false,
}) => {
  const getDisplayedValueByUnit = (unit, value) => {
    return unit === K.Format.Dollar
      ? displayDollar(value)
      : displayPercentage(value);
  };

  return (
    <Space direction="vertical" style={{ width: "100%" }}>
      <div>
        <Title style={{ margin: 0 }} level={5}>
          {clientName || "Current Rule"}
        </Title>
        {startDate && (
          <Space>
            <i className="icon-calendar icon-primary" />
            <Text className="text-caption">
              {epochTimeToDashUSFormat(startDate, false)}
            </Text>
            {isEditAllowed && (
              <EditStartDateButton
                commissionId={commissionId}
                lastRuleStartDate={lastRuleStartDate}
                startDate={startDate}
                onSuccess={onStartDateUpdated}
              />
            )}
          </Space>
        )}
      </div>
      <div className="commission-default-card">
        <Row>
          <CommissionDetailItem
            title={
              plan.thresholdType === K.CommissionThresholdType.Amount
                ? `Default Billing Threshold`
                : `Default Hires Threshold`
            }
            value={getThresholdValue(
              plan.thresholdType,
              plan.defaultBillingThreshold,
            )}
          />

          <CommissionDetailItem
            title="Applied Hires"
            value={getDisplayedValueByUnit(
              plan.appliedHireUnit,
              plan.appliedHire,
            )}
          />
          <CommissionDetailItem
            title="Sourced Hires"
            value={getDisplayedValueByUnit(
              plan.sourceHiredUnit,
              plan.sourceHired,
            )}
          />
          <CommissionDetailItem
            title="Referrals"
            value={getDisplayedValueByUnit(plan.referralUnit, plan.referral)}
          />
          <CommissionDetailItem
            title="Cancellations"
            value={getDisplayedValueByUnit(
              plan.cancellationsUnit,
              plan.cancellations,
            )}
          />
          <CommissionDetailItem
            title="Hiring Events"
            value={getDisplayedValueByUnit(
              plan.hiringEventUnit,
              plan.hiringEvent,
            )}
          />
          <CommissionDetailItem
            title="Rehire Referral"
            value={getDisplayedValueByUnit(
              plan.reHireReferralUnit,
              plan.reHireReferral,
            )}
          />
          <CommissionDetailItem
            title="Rehire Applied"
            value={getDisplayedValueByUnit(
              plan.reHireAppliedUnit,
              plan.reHireApplied,
            )}
          />
          <CommissionDetailItem
            title="Rehire Sourced"
            value={getDisplayedValueByUnit(
              plan.reHireSourcedUnit,
              plan.reHireSourced,
            )}
          />
          <CommissionDetailItem
            title="Internal"
            value={getDisplayedValueByUnit(plan.internalUnit, plan.internal)}
          />
        </Row>
      </div>
    </Space>
  );
};
